import { render, staticRenderFns } from "./NewsLetterEdit.vue?vue&type=template&id=154d3b6b&"
import script from "./NewsLetterEdit.vue?vue&type=script&lang=js&"
export * from "./NewsLetterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports